const errorModules = {
    modules: {
        REGISTER: [
            {
                errorId: "I023",
                errorCode: "REGISTER_GET_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with REGISTER-GET.",
            },
            {
                errorId: "I024",
                errorCode: "REGISTER_TOKEN_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with REGISTER-TOKEN.",
            },
            {
                errorId: "I025",
                errorCode: "REGISTER_VALID_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with REGISTER-VALID.",
            },
            {
                errorId: "I025",
                errorCode: "REGISTER_CREATE_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with REGISTER-CREATE.",
            },
        ],
        BUREAU: [
            {
                errorId: "B001",
                errorCode: "CUSTOMER2FA_BUREAU_CREDENTIALS_NOT_FOUND",
                detailedMessage:
                    "Customer 2FA Clear Sale Credentials Not Found For this Clientid.",
            },
            {
                errorId: "I007",
                errorCode: "BUREAU_TOKEN_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with Bureau-TOKEN.",
            },
            {
                errorId: "I008",
                errorCode: "BUREAU_TRANSACTION_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with BUREAU-TRANSACTION.",
            },
            {
                errorId: "I009",
                errorCode: "BUREAU_SCORE_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with BUREAU-SCORE.",
            },
            {
                errorId: "I010",
                errorCode: "BUREAU_RATINGS_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with BUREAU-RATINGS.",
            },
            {
                errorId: "C016",
                errorCode: "CUSTOMER2FA_DATA_LOW_RATING_EXCEPTION",
                detailedMessage: "Error in integration with BUREAU-RATINGS.",
            },
        ],
        STW: [
            {
                errorId: "I014",
                errorCode: "STW_MOBILEUSERS_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with STW-MOBILEUSERS.",
            },
            {
                errorId: "I015",
                errorCode: "STW_MOBILENUMBERS_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with STW-MOBILENUMBERS.",
            },
            {
                errorId: "I011",
                errorCode: "STW_EMAILADDRESSES_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with STW-EMAILADDRESSES.",
            },
            {
                errorId: "I016",
                errorCode: "STW_OTPCHANNELS_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with STW-OTPCHANNELS.",
            },
            {
                errorId: "I017",
                errorCode: "STW_OTPTOKENS_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with STW-OTPTOKENS.",
            },
            {
                errorId: "I020",
                errorCode: "STW_AUTHENTICATIONSNUMBERS_INTEGRATION_ERROR",
                detailedMessage:
                    "Error in integration with STW-AUTHENTICATIONSNUMBERS.",
            },
            {
                errorId: "I021",
                errorCode: "STW_ASSOCIATEDCREDENTIALS_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with STW-ASSOCIATEDCREDENTIALS.",
            },
            {
                errorId: "I022",
                errorCode: "STW_ASSOCIATEDACTIVATIONS_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with STW-ASSOCIATEDACTIVATION.",
            },
        ],
        PING: [
            {
                errorId: "I018",
                errorCode: "PING_REVOKE_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with PING_REVOKE",
            },
        ],
        AWS: [
            {
                errorId: "I003",
                errorCode: "AWS_SES_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with AWS-SES.",
            },
        ],
        APIGEE: [
            {
                errorId: "I005",
                errorCode: "APIGEE_TOKEN_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with APIGEE-TOKEN.",
            },
        ],
        CLAROID: [
            {
                errorId: "I006",
                errorCode: "OAG_CLAROID_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with OAG-CLAROID.",
            },
        ],
        SOA: [
            {
                errorId: "I013",
                errorCode: "SOA_SUBSCRIBERSLIST_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with SOA-SUBSCRIBERSLIST.",
            },
        ],
        MIND: [
            {
                errorId: "I019",
                errorCode: "MIND_INTEGRATION_ERROR",
                detailedMessage: "Error in integration with MIND-API.",
            },
        ],
    },
};

export const ErrorModuleHandler = (targetErrorCodePattern) => {
    const matchingModuleNames = Object.keys(errorModules.modules).filter(
        (moduleName) =>
            errorModules.modules[moduleName].some((errorDetail) =>
                errorDetail.errorCode.match(targetErrorCodePattern)
            )
    );

    return matchingModuleNames.length > 0
        ? `module-${matchingModuleNames[0]}`
        : "module-credential";
};
